import React from 'react';

import '../css/ui/Loading.scss';
import KTween from '../core/KTween';

export default class Loading extends React.Component
{

	container;
	image;
	spritesheet;
	finished = false;
	_loaded = false;

	_logoOpacity = 1;
	_hidePosition = 1;

	spriteProps = {
		width: 500,
		height: 500,
		cols: 1,
		rows: 40,
		frames: 40,
		currentFrame: 0,
	}

	componentDidMount()
	{
		if(!this.image)
		{
			this.image = new Image();
			this.image.addEventListener('load', this._imageLoaded);
			this.image.src = 'assets/images/home/logo_spritesheet.png';
		}
	}

	get logoOpacity()
	{
		return this._logoOpacity;
	}

	set logoOpacity(value)
	{
		this._logoOpacity = value;
		this.spritesheet.style['opacity'] = value;
	}

	get hidePosition()
	{
		return this._hidePosition;
	}

	set hidePosition(value)
	{
		this._hidePosition = value;
		this.container.style['top'] = (1 - value) * 100 + '%';
	}

	loaded()
	{
		this._loaded = true;
		this.checkLoaded();
	}

	_imageLoaded = () =>
	{
		this.spritesheet = document.createElement('div');
		this.spritesheet.className = 'spritesheet';
		this.spritesheet.appendChild(this.image);
		this.container.appendChild(this.spritesheet);

		this.image.style['width'] = (100 * this.spriteProps.cols) + '%';
		this.image.style['height'] = (100 * this.spriteProps.rows) + '%';
		KTween.tween(this.spriteProps, {currentFrame: this.spriteProps.frames, onUpdate: this._updateFrame, onComplete: this._animComplete}, 'linear', 1.5);
		// this._updateFrame();
	}

	_updateFrame = () =>
	{
		let frame = Math.round(this.spriteProps.currentFrame);
		if(frame >= this.spriteProps.frames) frame = this.spriteProps.frames - 1;
		this.image.style['left'] = (- frame % this.spriteProps.cols) * (100) + '%';
		this.image.style['top'] = - Math.floor(frame / this.spriteProps.cols) * (100) + '%';
	}

	_animComplete = () =>
	{
		this.finished = true;
		this.checkLoaded();
	}

	checkLoaded()
	{
		if(this.finished && (this._loaded || document.readyState == 'complete'))
		{
			KTween.tween(this, {logoOpacity: 0}, 'easeOutQuart', 0.2, 0.2);
			KTween.tween(this, {hidePosition: 0}, 'easeInOutQuart', 0.3, 0.3);
		}
	}

	render()
	{
		return (
			<div className='loading' ref={r => this.container = r}>
			</div>
		);
	}
}